import GenericDB from './generic-db';

export default class ReportTemplatesDB extends GenericDB {
  constructor() {
    super('reportTemplates');
  }
}
